import { useEffect, useState } from "react";
import { ServiceTypes } from "src/api/adminMemo/adminmemo-types";
import { patchContractManage_RCA26 } from "src/api/contract/contract-api";
import { ContractApplicationModel, DetailTotalData } from "src/api/contract/contract-types";
import { useApiOperation } from "src/api/hooks";
import AdminMemoV3 from "src/components/AdminMemoV3/AdminMemoV3";
import { BaseButton } from "src/components/BaseButton";
import GoToListButton from "src/components/GoToListButton";
import BaseSectionTitle from "src/components/layout/BaseSectionTitle";
import RegistrationInformation from "src/components/RegistrationInformation";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import ContractBuildingRooms from "src/pages/contract/commonComponents/ContractBuilngRooms";
import ContractorInfo from "src/pages/contract/commonComponents/ContractorInfo";
import ContractProductInfo from "src/pages/contract/commonComponents/ContractProductInfo";
import useUsageApplication from "src/pages/product/hooks/useUsageApplication";
import { TAAP_THEME_COLORS } from "src/pages/product/product-types";
import { useModal } from "src/recoil/modalState/hook";
interface ContractBasicProp {
  detailData: DetailTotalData; //상품 상세 조회 정보
  setData: () => Promise<void>;
}
const BasicInfo = ({ detailData, setData }: ContractBasicProp) => {
  const { contract } = detailData;
  const { setBaseModal } = useModal();
  const { isAuthority } = usePartnerAuthority();

  const [isTaapColorEdit, setIsTaapColorEdit] = useState(false);
  const [taapColor, setTaapColor] = useState("");

  const [contractApplication, setContractApplication] = useState<ContractApplicationModel | null>();

  const { executeAsync: editContractManage } = useApiOperation(patchContractManage_RCA26);

  const handleTaapColorEdit = async () => {
    const { data } = await editContractManage({
      id: Number(contract?.contractManageId),
      contractManage: { contractManageId: Number(contract?.contractManageId), colorName: taapColor },
    });
    if (data.data) {
      setIsTaapColorEdit(false);
      setBaseModal({ isOpen: false });
      await setData();
    }
  };
  const { getContractUsageApplication } = useUsageApplication();

  // 계약 > 이용신청서 정보 조회
  const getContractApplication = async () => {
    if (contract?.contractId) {
      const result = await getContractUsageApplication({ contractId: Number(contract?.contractId) });
      setContractApplication(result);
    }
  };
  useEffect(() => {
    (async () => {
      if (contract?.contractId) {
        getContractApplication();
      }
    })();
  }, [contract?.contractId]);

  return (
    <>
      <div className="contents-container__scroll">
        <div className="contents-container__wrap">
          {/* 상품 정보 */}
          <ContractProductInfo detailData={detailData!} isUseApplication={!!contractApplication?.applicationBody.formData} />
          {/* 신청자 정보 */}
          <ContractorInfo
            detailData={detailData!}
            detailFlag={true}
            contractApplication={contractApplication}
            getContractApplication={getContractApplication}
          />
          {/* 건물 정보 */}
          <ContractBuildingRooms detailData={detailData!} />

          {/* 탭 홈화면 테마색상 */}
          <article className="contents-container__wrap-article full-width">
            <div className="flex-center-between">
              <BaseSectionTitle title={"Taap 홈화면"} />
              {isTaapColorEdit ? (
                <div className="flex-center">
                  <BaseButton
                    title="취소"
                    className="mr5 color-white size-small"
                    onClick={() => {
                      setTaapColor("");
                      setIsTaapColorEdit(false);
                    }}
                  />
                  <BaseButton
                    title="저장"
                    className="size-small"
                    onClick={() =>
                      setBaseModal({
                        isOpen: true,
                        title: "저장하시겠습니까?",
                        btnLeftTitle: "취소",
                        btnRightTitle: "확인",
                        onClose: () => {
                          setIsTaapColorEdit(false);
                          setBaseModal({ isOpen: false });
                        },
                        onClick: () => handleTaapColorEdit(),
                      })
                    }
                  />
                </div>
              ) : (
                <>{isAuthority("w") && <BaseButton title="수정" className="size-small" onClick={() => setIsTaapColorEdit(true)} />}</>
              )}
            </div>

            {/* 테마 색상 */}
            <div className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p className={isTaapColorEdit ? "required" : ""}>테마색상</p>
              </div>
              <div className="contents-container__grid-contents product-theme">
                {isTaapColorEdit ? (
                  <div className="flex-row flex-start-start">
                    <div className={`product-theme__selected ${taapColor ? taapColor : contract?.colorName ?? ""}`}></div>
                    <div className="product-theme__colors">
                      {TAAP_THEME_COLORS.map((colorCode: string) => (
                        <div key={colorCode} className={`colors ${colorCode}`} onClick={() => setTaapColor(colorCode)}></div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className={`product-theme ${contract?.colorName ?? ""} h40 w40`}>{!contract?.colorName && <span>-</span>}</div>
                )}
              </div>
            </div>
          </article>

          {/* 등록 정보 */}
          <RegistrationInformation data={contract} />
          {/* 관리자 메모 */}
          <AdminMemoV3 serviceId={Number(detailData?.contract?.contractId)} serviceType={ServiceTypes.SERVICE_CONTRACT} />
        </div>
      </div>
      <div className="contents-container__btn-wrap">
        <div className="left-area d-flex">
          <GoToListButton />
        </div>
        <div className="right-area"></div>
      </div>
    </>
  );
};

export default BasicInfo;
